export { default as ProductList } from './ProductList';
export { default as ProductEdit } from './ProductEdit';


// WEBPACK FOOTER //
// ./src/modules/Product/pages/index.ts